import { render, staticRenderFns } from "./editSubIbRuleDialog.vue?vue&type=template&id=c2c595cc"
import script from "./editSubIbRuleDialog.vue?vue&type=script&lang=js"
export * from "./editSubIbRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./editSubIbRuleDialog.vue?vue&type=style&index=0&id=c2c595cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports